import { Page } from '@/core/architecture'

import { StorePurchaseOrderDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * StorePurchaseOrderDetail Page
 * Implemented as a practical sample.
 */
export const StorePurchaseOrderDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <StorePurchaseOrderDetailTemplate state={state} {...actions} />
}
